import { filter, fromEvent, map, partition } from 'rxjs';

import redirectToSearchCommunityResults from '../../components/redirectHandler';

const searchSubmitElement = document.querySelector('[data-search-submit]');

/**
 * redirectToSearchCommunityResults: Redirects the user to the search results
 * page for the specified location.
 * @param {string} searchValue - The location value to be used in the search results page URL.
 * Note: 'form' is being used for the old typeadhead and 'data-right-rail-search'
 * is being used for the new typeahead.
 */
const getContainerByElement = (element) => {
  if (!element) {
    return null;
  }
  return element.closest('form') || element.closest('[data-right-rail-search]');
};

const searchInput = document.getElementById('blog_typeahead_input');
const searchForm = getContainerByElement(searchInput);

/**
 * displayErrorContainer: Opens the error container messages.
 */
const displayErrorContainer = function () {
    const errorContainer = document.getElementById('blog_typeahead_error');
    const form = getContainerByElement(errorContainer);
    const errorContainers = errorContainer.parentElement.querySelectorAll('[data-typeahead-error]');

    errorContainers.forEach((container) => { container.style.display = 'none'});

    if (!form) { return; }
    form.classList.add('error');
    errorContainer.style.display = 'block';
  }

  /**
   * Observable to validate if the search text is wrong to show error message or perform redirects
   */
  const searchSubmit$ = fromEvent(searchSubmitElement, 'click').pipe(
    filter(event => event.target?.matches('[data-search-submit]')),
    map(() => document.getElementById('blog_typeahead_input').value.trim())
  );

  const [submitSearchText$, displayError$] = partition(
    searchSubmit$,
    (searchValue) => searchValue
  );

  submitSearchText$.subscribe(redirectToSearchCommunityResults);
  displayError$.subscribe(displayErrorContainer);


  /**
   * closeErrorContainer: Closes the error container messages.
   */
  const closeErrorContainer = function () {
    const errorContainer = document.getElementById('blog_typeahead_error');
    const form = getContainerByElement(errorContainer);
    const errorContainers = errorContainer.parentElement.querySelectorAll('[data-typeahead-error]');

    errorContainers.forEach((container) => { container.style.display = 'none'});

    if (!form) { return; }
    form.classList.remove('error');
    errorContainer.style.display = 'none';
  };

const formOutClick$ = fromEvent(document, 'click').pipe(filter((event) => (
  !event.target.matches('[data-search-submit]') && !searchForm?.contains(event.target)
)));
formOutClick$.subscribe(closeErrorContainer);